import {configure, getConfiguration, on, P2P, send} from "@rlx/feim";
import BaseManager from "./BaseManager";
import {receiveMessageTypes} from "./GameBridgeManager";

export const relaxReceiveMessageTypes = {
    OPRG_GAME_PAYTABLE: 'oprg_GamePayTable',
    OPRG_UPDATE_BALANCE: 'oprg_UpdateBalance',
};

export default class RelaxManager extends BaseManager {

    constructor() {
        super()
    }

    get configuration() {
        return getConfiguration
    }

    init(adapter) {
        super.init(adapter)
        this.getEvent()
        window.addEventListener('message', this._onPostMessage.bind(this));
    }


    _onPostMessage(event) {
        const {adapter} = this
        const message = event.data;

        switch (message.rgMessage ? message.rgMessage.toLowerCase() : undefined) {
            case relaxReceiveMessageTypes.OPRG_GAME_PAYTABLE.toLowerCase():
                adapter.togglePaytable()
                break;
            case relaxReceiveMessageTypes.OPRG_UPDATE_BALANCE.toLowerCase():
                adapter.updateBalance()
                break;
        }
    }

    getEvent() {
        const {adapter} = this
        on.refreshBalance(() => {
            adapter.updateBalance()
        });
        on.freeze(() => {
            adapter.freeze()
        });
        on.unfreeze(() => {
            adapter.unfreeze()
        });
        on.updateSettings((newSetting) => {
            adapter.updateSettings(newSetting)
            // Only the changed setting is in newSetting, not the entire settings state
        });
        on.pauseAutoPlay(() => {
            adapter.stopAutospins()
        });
        on.togglePaytable(() => adapter.togglePaytable())
        on.toggleGameHelp(() => adapter.showHelp())
    }

    relaxConfigure(data) {
        const {adapter} = this
        console.log("RELAX MANAGER:: getConfiguration", data)
        configure({
            // The received response from /getclientconfig/, or an object adhering to its format
            // (Relax game server users only):
            // clientConfig: clientconfigResponse,
            // The casino login response, or an object adhering to its format
            // (Relax game server users only):
            // loginResponse: casinoLoginResponse,

            // When clientConfig and loginResponse cannot be provided
            // (only when not using the Relax game server):
            p2pConfig: {currency: data.currency},

            /* If set to true, FEIM will handle the responsibilities of RgPostMessageAPI library.
            If true, RgPostMessageAPI library or any equivalent/duplicate integration must be
            removed from the game. */
            handleRgPostMessageAPI: true,

            /* Some jurisdictions require that the game needs to wait for a user confirmation when
            a bonus game is reached. Set this to false if the game handles it internally. */
            handleFeaturePause: true,

            // Optional, see showError:
            // showErrorMessageCallback: MY_GAME.showInGameErrorMessage,
        });
        P2P.onRealityCheckChoiceRequired((choice) => {
            console.log("RELAX MANAGER:: onRealityCheckChoiceRequired")
            adapter.realityCheckPopup()
        })
        send.updateSettings({sounds: true});
        send.gameLoadStarted();
        console.log("RELAX MANAGER:: getConfiguration().operatorHandlesErrors", getConfiguration().operatorHandlesErrors)
    }

    loadProgress(progress) {
        // console.log('  RA : relaxConfigure ', progress)
        send.gameLoadProgress(Math.floor(progress));
    }

    loadCompleted() {
        send.gameLoadCompleted();
    }

    audioToggle(data) {
        send.updateSettings({sounds: !!data});
    }

    roundStart(value = 0) {
        send.roundStarted({balance: value});
    }

    roundEnd({balance = 0, totalBet = 0, totalWin = 0}) {
        let gamefinishedEndpointResponse = null
        send.roundFinished({
            balance: balance,
            bet: totalBet,
            win: totalWin,
            finishedResponse: gamefinishedEndpointResponse
        });
    }

    featureStart() {
        send.featureStarted();
    }

    featureFinish() {
        send.featureFinished();
    }

    betUpdate(value) {
        send.betUpdate(value);
    }

    balanceUpdate(value) {
        send.balanceUpdate(value);
    }

    winUpdate(value) {
        send.winUpdate({win: value});
    }

    autoPlayStarted() {
        send.autoPlayStarted();
    }

    autoplayFinished() {
        send.autoPlayFinished();
    }

    closed() {
        if (!send.exitGame()) {
            // The game's default exit functionality, probably going to homeurl
            this.adapter.quitHandler()
        } else {
            // Nothing needs to be done, the operator will close the game frame
        }
    }

    insufficientFunds() {
        send.openQuickDeposit()
    }

    updateBalance() {
        this.adapter.updateBalance()
    }

    stopAutospins() {
        this.adapter.stopAutospins()
    }

    setAudio(value) {
        this.adapter.setAudio(value)
    }

    onShowOperatorHandlesErrors(errorResponse) {
        send.errorMessage(errorResponse);
    }

    showHelp() {
        this.adapter.showHelp()
    }

    togglePaytable() {
        this.adapter.togglePaytable()
    }

    errorMessage(data) {
        send.errorMessage(data);
    }

}
